import styled from 'styled-components';

const s = {
  Container: styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 24px 24px 40px;
    border-radius: 24px;
    border: 1px solid #e5e8ea;
    &:hover {
      border: 1px solid #008aff;
    }
    gap: 24px;
  `,
  Div: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
  Top: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,

  Title: styled.div`
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 700;
    font-size: 24px;
  `,
  Comment: styled.span`
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 500;
    font-size: 13px;
    color: #616161;
  `,

  PriceDiv: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  Discount: styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
  `,

  Row: styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 4px;
    font-weight: 700;
  `,

  EarlyBird: styled.div`
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 500;
    font-size: 13px;
    color: #008aff;
    padding: 2px 6px;
    border-radius: 4px;
    background-color: #e8f1ff;
    align-items: center;
    justify-content: center;
  `,
  NormalPrice: styled.div``,

  Dropdown: styled.div`
    padding: 14px 16px;
    border-radius: 8px;
    border: 1px solid #e5e8ea;
    background-color: #f7f8fc;
  `,

  StartButton: styled.button`
    font-weight: 700;
    font-size: 16px;
    padding: 14px 28px;
    border-radius: 8px;
    border: 1px solid #008aff;
    background-color: transparent;
    color: #008aff;
    pointer: cursor;
    display: flex;
    align-items: center;
    justify-content: center;
    font-align: center;
    &:hover {
      background-color: #008aff;
      color: #fff;
    }
  `,

  BenefitList: styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
  Benefit: styled.div`
    display: flex;
    flex-direction: row;
    gap: 6px;
    font-weight: 500;
    font-size: 16px;
  `,
};

export default s;
